export const ACCOUNT_OPTIONS = {
  // TODO: need to determine what correct urls are
  PROFILE: {
    id: "settings",
    content: "Profile",
    url: "/account/settings",
  },
  CLASS: {
    id: "classes",
    content: "Class directory",
    url: "/account/classes",
  },
  STUDENTS: {
    id: "students",
    content: "Student directory",
    url: "/account/students",
  },
  FACULTY: {
    id: "faculty",
    content: "Faculty directory",
    url: "/account/faculty",
  },
};

const menuOptions = [
  {
    id: "account",
    title: "Settings",
    options: [
      {
        id: ACCOUNT_OPTIONS.PROFILE.id,
        content: ACCOUNT_OPTIONS.PROFILE.content,
        ariaLabel: ACCOUNT_OPTIONS.PROFILE.content,
        title: ACCOUNT_OPTIONS.PROFILE.content,
        url: ACCOUNT_OPTIONS.PROFILE.url,
      },
      {
        id: ACCOUNT_OPTIONS.CLASS.id,
        content: ACCOUNT_OPTIONS.CLASS.content,
        ariaLabel: ACCOUNT_OPTIONS.CLASS.content,
        title: ACCOUNT_OPTIONS.CLASS.content,
        url: ACCOUNT_OPTIONS.CLASS.url,
      },
      {
        id: ACCOUNT_OPTIONS.STUDENTS.id,
        content: ACCOUNT_OPTIONS.STUDENTS.content,
        ariaLabel: ACCOUNT_OPTIONS.STUDENTS.content,
        title: ACCOUNT_OPTIONS.STUDENTS.content,
        url: ACCOUNT_OPTIONS.STUDENTS.url,
      },
      {
        id: ACCOUNT_OPTIONS.FACULTY.id,
        content: ACCOUNT_OPTIONS.FACULTY.content,
        ariaLabel: ACCOUNT_OPTIONS.FACULTY.content,
        title: ACCOUNT_OPTIONS.FACULTY.content,
        url: ACCOUNT_OPTIONS.FACULTY.url,
      },
    ],
  },
];

export const breadcrumbOptions = [
  {
    href: ACCOUNT_OPTIONS.PROFILE.url,
    contents: ACCOUNT_OPTIONS.PROFILE.content,
  },
  {
    href: ACCOUNT_OPTIONS.CLASS.url,
    contents: ACCOUNT_OPTIONS.CLASS.content,
  },
  {
    href: ACCOUNT_OPTIONS.STUDENTS.url,
    contents: ACCOUNT_OPTIONS.STUDENTS.content,
  },
  {
    href: ACCOUNT_OPTIONS.FACULTY.url,
    contents: ACCOUNT_OPTIONS.FACULTY.content,
  },
];

export default menuOptions;
